import { ErrorBoundary as ZenErrorBoundary } from '@zenbusiness/application-commons-logging';

function ErrorBoundary({ children, ...delegated }) {
  return (
    <ZenErrorBoundary
      resetOnLocationChange
      {...delegated}
    >
      {children}
    </ZenErrorBoundary>
  );
}

export default ErrorBoundary;
